export default String.raw`
<div class="related__swiper recommended-products-list-js" data-section="{{ section }}">
    <div class="mask-right"></div>
    <div class="swiper-wrapper">
        {% for product in products %}
            {% include 'partials/product/recommended-products-item.html', product: product, isDiscountItem: isDiscountItem, index: forloop.index %}
        {% endfor %}
    </div>
    <div class="arrow shadowed related__prev">
        <svg class="arrow__icon">
            <use href='css/img/fontawesome-icons.svg?v={{lqTS}}#chevron-right-{{ settings.iconStyle }}'></use>
        </svg>
    </div>
    <div class="arrow shadowed related__next">
        <svg class="arrow__icon">
            <use href='css/img/fontawesome-icons.svg?v={{lqTS}}#chevron-right-{{ settings.iconStyle }}'></use>
        </svg>
    </div>
</div>
`